export const DEFAULT_TASK_API_PREFIX = '/system/task'
